import { TrendingUp, TrendingDown } from "lucide-react";
import { LineChart, Line, ResponsiveContainer } from "recharts";

const indicators = [
  { key: "gdp_growth", label: "GDP Growth", unit: "%", color: "#22d3ee", good: "up" },
  { key: "inflation", label: "Inflation Rate", unit: "%", color: "#f59e0b", good: "down" },
  { key: "pharma_index", label: "Pharma Market Index", unit: "", color: "#8b5cf6", good: "up" },
  { key: "healthcare_spend", label: "Healthcare Spend Growth", unit: "%", color: "#34d399", good: "up" },
  { key: "currency_rate", label: "USD/INR Rate", unit: "", color: "#f472b6", good: "down" },
];

const monthLabel = (m) => {
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return months[parseInt(m.split("-")[1]) - 1];
};

export default function MacroFactors({ factors }) {
  if (!factors || factors.length === 0) return null;

  const latest = factors[factors.length - 1];
  const prev = factors.length > 1 ? factors[factors.length - 2] : latest;

  return (
    <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-6" data-testid="macro-factors">
      <h3 className="text-base font-semibold text-white mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Macroeconomic Indicators</h3>
      <p className="text-xs text-slate-500 mb-4">External factors influencing demand</p>
      <div className="space-y-3">
        {indicators.map(ind => {
          const val = latest[ind.key];
          const prevVal = prev[ind.key];
          const delta = val - prevVal;
          const isPositive = ind.good === "up" ? delta >= 0 : delta <= 0;
          const sparkData = factors.map(f => ({ v: f[ind.key] }));

          return (
            <div key={ind.key} className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-800/30 transition-colors">
              <div className="flex-1 min-w-0">
                <p className="text-xs text-slate-400">{ind.label}</p>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-sm font-semibold text-white">{val}{ind.unit}</span>
                  <span className={`flex items-center gap-0.5 text-[10px] ${isPositive ? 'text-emerald-400' : 'text-red-400'}`}>
                    {delta >= 0 ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
                    {Math.abs(delta).toFixed(1)}{ind.unit}
                  </span>
                </div>
              </div>
              <div className="w-20 h-8">
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={sparkData}>
                    <Line type="monotone" dataKey="v" stroke={ind.color} strokeWidth={1.5} dot={false} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
